// Translations for Amb Tu Platform
export const translations = {
  es: {
    // Navigation
    nav: {
      conversational: "Conversacional",
      reputational: "Monitorización Reputacional",
      tools: "Herramientas",
      analytics: "Analíticas",
      agentAnalytics: "Analíticas Agente IA",
      campaigns: "Campañas", 
      conversations: "Conversaciones",
      informes: "Informes",
      reports: "Reportes",
      osint: "OSINT Monitor",
      settings: "Configuración"
    },
    // Analytics Panel
    analytics: {
      title: "Analíticas Outbound",
      subtitle: "Toda la información a un click",
      description: "Realice un seguimiento, gestione sus clientes y su actividad",
      lastDays: "Últimos 30 días",
      totalCalls: "Total Llamadas",
      attendedCalls: "Atendidas", 
      abandonedCalls: "Abandonadas",
      cancelledCalls: "Canceladas",
      avgDuration: "Duración Media",
      callDistribution: "Distribución de resultados de llamadas",
      callEvolution: "Evolución de llamadas",
      campaignResults: "Resultados de campañas",
      contracts: "Contrataciones",
      occupancy: "Ocupación",
      tma: "TMA",
      tme: "TME",
      confirmed: "Confirmada",
      modified: "Modificada",
      notConfirmed: "No confirmada",
      cancelled: "Cancelada",
      dashboardReport: "Informe Detallado - Análisis Avanzado",
      dashboardPlaceholder: "Dashboards interactivos con análisis avanzado",
      // Tab system labels
      tabs: {
        performanceMetrics: "Métricas de Rendimiento",
        conversationAnalytics: "Análisis Conversacional", 
        realTimeDashboard: "Dashboard en Tiempo Real",
        kpiOverview: "Resumen de KPIs",
        performanceDesc: "Métricas principales de rendimiento y productividad",
        conversationDesc: "Análisis detallado de conversaciones y transcripciones",
        realTimeDesc: "Monitoreo en tiempo real de actividad y llamadas",
        kpiDesc: "Indicadores clave de rendimiento y objetivos"
      }
    },
    // Campaigns Panel
    campaigns: {
      title: "Mis campañas",
      newCampaign: "Nueva campaña",
      search: "Buscar",
      state: "Estado",
      clearFilters: "Borrar filtros",
      phoneNumber: "Número de teléfono",
      campaignResult: "Resultado campaña",
      contacts: "Contactos",
      calls: "Llamadas",
      creationDate: "Fecha creación",
      status: "Estado",
      draft: "Draft",
      paused: "Pausada",
      completed: "Realizada",
      export: "Exportar",
      // Campaign Management
      management: {
        title: "Gestión de Campañas Conversacionales",
        subtitle: "Administra campañas de voicebots, chatbots y agentes humanos para diferentes industrias"
      },
      types: {
        sales: "Ventas",
        support: "Atención al Cliente", 
        collections: "Cobranzas",
        surveys: "Encuestas",
        appointments: "Citas",
        retention: "Retención"
      },
      industries: {
        banking: "Banca y Finanzas",
        healthcare: "Salud",
        retail: "Retail",
        telecom: "Telecomunicaciones", 
        insurance: "Seguros",
        automotive: "Automotriz"
      },
      channels: {
        voicebot: "VoiceBot",
        chatbot: "ChatBot",
        human: "Agentes Humanos",
        hybrid: "Híbrido"
      }
    },
    // Conversations Panel
    conversations: {
      title: "Conversaciones",
      all: "Todos",
      confirmed: "Confirmado",
      date: "Fecha",
      time: "Hora",
      phoneNumber: "Número de teléfono",
      selectConversation: "Selecciona una conversación para ver los detalles",
      back: "Volver",
      contactInfo: "Ver información de contacto",
      alternativeContact: "Contacto alternativo",
      fixedField: "Campo fijo",
      callAttempts: "Intentos de llamada",
      callOrigin: "Origen de llamada",
      agentVoice: "Voz de agente",
      campaign: "Campaña",
      callState: "Estado",
      result: "Resultado",
      duration: "Duración",
      hungUpBy: "Colgado por",
      callSummary: "Resumen de llamada",
      callResults: "Resultados de llamada",
      alternativeTime: "Hora alternativa",
      deliveryDate: "Fecha de entrega",
      transcription: "Transcripción",
      thinking: "Pensamiento",
      conversation: "Conversación",
      agent: "Agente Virtual",
      customer: "Cliente"
    },
    // Reports Panel
    reports: {
      title: "Ventas Madrid",
      finished: "Finalizado el 23 de enero de 2025",
      download: "Descargar",
      salesDistribution: "Distribución de tus ventas",
      scheduled: "Agendada",
      interested: "Interesado", 
      pending: "Pendiente",
      rejected: "Rechazada",
      evaluator: "Evaluador de Calidad",
      evaluatorDesc: "Evalúa conversaciones con comprensión real. Calidad basada en comprensión.",
      globalRating: "Valoración global",
      optimalPerformance: "Tu agente está teniendo un desempeño óptimo en todas las áreas clave.",
      customerSatisfaction: "Satisfacción del cliente",
      callCompliance: "Cumplitud de llamada",
      responseComplexity: "Complejidad de respuestas",
      clarityIndex: "Índice de claridad",
      veryGood: "Muy bueno",
      generalSummary: "Resumen general",
      totalContacts: "Total contactos",
      callAttempts: "Intentos de llamada",
      totalConsumption: "Consumo total",
      campaignCost: "Coste de campaña",
      callBreakdown: "Así fueron tus llamadas",
      completed: "Realizadas",
      errors: "Erróneas",
      returned: "Devueltas",
      voicemails: "Buzones de voz",
      rescheduled: "Reprogramadas",
      detailedAnalysis: "Análisis Detallado - Informes Avanzados",
      dashboardPlaceholder: "Informes detallados con métricas avanzadas",
      // Tab system labels for reports
      tabs: {
        campaignReports: "Informes de Campañas",
        osintReports: "Informes OSINT",
        customReports: "Informes Personalizados",
        performanceReports: "Informes de Rendimiento",
        campaignDesc: "Análisis detallado del rendimiento de campañas",
        osintDesc: "Informes de monitorización y análisis reputacional",
        customDesc: "Informes personalizados y configurables",
        performanceDesc: "Métricas de rendimiento y KPIs principales"
      }
    },
    // OSINT Panel
    osint: {
      title: "OSINT Monitor",
      description: "Monitorización de fuentes abiertas y análisis de reputación",
      filters: "Filtros",
      newSearch: "Nueva búsqueda",
      overview: "Resumen",
      mentions: "Menciones",
      alerts: "Alertas",
      competitors: "Competencia",
      totalMentions: "Menciones Totales",
      positiveSentiment: "Sentimiento Positivo",
      activeAlerts: "Alertas Activas",
      monitoredSources: "Fuentes Monitoreadas",
      mentionsByPlatform: "Menciones por Plataforma",
      recentMentions: "Menciones Recientes",
      sentiment: "Sentimiento",
      interactions: "interacciones",
      allMentions: "Todas las Menciones",
      searchMentions: "Buscar menciones...",
      socialMonitoring: "Esta sección se conectará con APIs de monitorización de redes sociales",
      keywordAlerts: "Alertas de Palabras Clave",
      seeDetails: "Ver detalles",
      competitorAnalysis: "Análisis de Competencia",
      positive: "positive",
      negative: "negative",
      neutral: "neutral"
    },
    // Settings Panel
    settings: {
      title: "Configuración del Sistema",
      description: "Administra tu cuenta, notificaciones, seguridad e integraciones",
      sections: {
        account: "Cuenta de Usuario",
        notifications: "Notificaciones", 
        security: "Seguridad",
        integrations: "Integraciones",
        dashboards: "Dashboards",
        appearance: "Apariencia",
        export: "Exportar Datos"
      },
      account: {
        title: "Configuración de Cuenta",
        fullName: "Nombre Completo",
        email: "Email",
        phone: "Teléfono",
        role: "Rol",
        department: "Departamento",
        roles: {
          administrator: "Administrador",
          manager: "Manager",
          agent: "Agente",
          analyst: "Analista"
        },
        save: "Guardar Cambios"
      },
      notifications: {
        title: "Configuración de Notificaciones",
        channels: "Canales de Notificación",
        types: "Tipos de Notificación",
        email: "Email",
        emailDesc: "Recibir notificaciones por correo electrónico",
        sms: "SMS",
        smsDesc: "Recibir notificaciones por mensaje de texto",
        push: "Push",
        pushDesc: "Notificaciones push en el navegador",
        campaigns: "Campañas",
        campaignsDesc: "Notificaciones sobre estado de campañas",
        reports: "Informes",
        reportsDesc: "Notificaciones sobre nuevos informes",
        alerts: "Alertas",
        alertsDesc: "Alertas críticas y de seguridad",
        save: "Guardar Notificaciones"
      },
      security: {
        title: "Configuración de Seguridad",
        changePassword: "Cambiar Contraseña",
        currentPassword: "Contraseña Actual",
        newPassword: "Nueva Contraseña",
        confirmPassword: "Confirmar Nueva Contraseña",
        twoFactor: "Autenticación de Dos Factores",
        twoFactorDisabled: "2FA Desactivado",
        twoFactorDesc: "Añade una capa extra de seguridad a tu cuenta",
        activate2FA: "Activar 2FA",
        activeSessions: "Sesiones Activas",
        currentBrowser: "Navegador Actual",
        currentDevice: "Chrome en Windows • Activa ahora",
        mobileDevice: "Dispositivo Móvil",
        mobileDesc: "Safari en iOS • Hace 2 horas",
        closeSession: "Cerrar Sesión",
        current: "Actual"
      },
      integrations: {
        title: "Integraciones y APIs",
        apiKey: "API Key Amb Tu",
        apiKeyDesc: "Clave de API para integraciones externas",
        copy: "Copiar",
        regenerate: "Regenerar",
        webhook: "Webhook URL",
        webhookDesc: "Endpoint para recibir notificaciones",
        externalDb: "Base de Datos Externa",
        externalDbDesc: "Conexión a tu CRM o base de datos",
        disconnected: "Desconectado",
        configure: "Configurar"
      },
      export: {
        title: "Exportar y Backup de Datos",
        exportData: "Exportar Datos",
        campaignData: "Datos de Campañas",
        campaignDataDesc: "Exportar todas las campañas y sus resultados",
        analytics: "Análisis y Métricas",
        analyticsDesc: "Exportar dashboards y análisis completos",
        fullConfig: "Configuración Completa",
        fullConfigDesc: "Backup completo de toda la configuración",
        exportCsv: "Exportar CSV",
        exportPdf: "Exportar PDF",
        exportJson: "Exportar JSON",
        importConfig: "Importar Configuración",
        importDesc: "Arrastra un archivo JSON o haz clic para seleccionar",
        selectFile: "Seleccionar Archivo"
      }
    },
    // Period Options
    periods: {
      last7days: "Últimos 7 días",
      last30days: "Últimos 30 días", 
      last90days: "Últimos 90 días",
      thisMonth: "Este mes",
      lastMonth: "Mes anterior",
      thisYear: "Este año"
    },
    // Analytics Types
    analyticsTypes: {
      outbound: "Outbound",
      inbound: "Inbound", 
      outboundDesc: "Campañas Salientes",
      inboundDesc: "Atención Entrante"
    },
    // Table Headers
    table: {
      answered: "Contestados",
      notAnswered: "No contestados",
      detailOf: "Ver detalles de"
    },
    // Campaign Management
    campaignMgmt: {
      title: "Gestión de Campañas Conversacionales",
      subtitle: "Administra campañas de voicebots, chatbots y agentes humanos para diferentes industrias",
      statsActive: "Campañas Activas",
      statsContacts: "Contactos Totales",
      statsSuccess: "Tasa Éxito Promedio",
      statsRevenue: "Ingresos Generados",
      filters: "Filtros",
      allIndustries: "Todas las industrias",
      allTypes: "Todos los tipos",
      tabAll: "Todas",
      tabActive: "Activas",
      tabPaused: "Pausadas", 
      tabCompleted: "Completadas",
      progress: "Progreso",
      totalContacts: "Contactos Totales",
      contactsCompleted: "Contactos Realizados",
      successRate: "Tasa de Éxito",
      avgDuration: "Duración Promedio",
      revenueGenerated: "Ingresos Generados",
      pauseCampaign: "Pausar",
      resumeCampaign: "Continuar",
      viewDetails: "Ver Detalles",
      types: {
        sales: "Ventas",
        support: "Atención al Cliente",
        collections: "Cobranzas", 
        surveys: "Encuestas",
        appointments: "Citas",
        retention: "Retención"
      },
      industries: {
        banking: "Banca y Finanzas",
        healthcare: "Salud",
        retail: "Retail",
        telecom: "Telecomunicaciones",
        insurance: "Seguros",
        automotive: "Automotriz"
      },
      channels: {
        voicebot: "VoiceBot",
        chatbot: "ChatBot",
        human: "Agentes Humanos",
        hybrid: "Híbrido"
      }
    },
    // Campaign Details Modal
    campaignDetails: {
      edit: "Editar",
      duplicate: "Duplicar",
      export: "Exportar",
      totalContacts: "Contactos Totales",
      contactsCompleted: "Contactos Realizados", 
      successRate: "Tasa de Éxito",
      avgDuration: "Duración Promedio",
      revenueGenerated: "Ingresos Generados",
      pauseCampaign: "Pausar Campaña",
      resumeCampaign: "Reanudar Campaña",
      configure: "Configurar",
      refreshData: "Actualizar Datos",
      detailedAnalysis: "Análisis Detallado",
      interactiveDashboards: "Dashboards interactivos específicos para esta campaña",
      status: {
        active: "Activa",
        paused: "Pausada",
        completed: "Completada"
      }
    },
    // Tab System
    tabSystem: {
      refresh: "Actualizar",
      openNew: "Abrir en nueva ventana",
      fullscreen: "Pantalla completa",
      loading: "Cargando dashboard...",
      error: "Error al cargar el dashboard",
      errorDesc: "No se pudo cargar el dashboard desde:",
      retry: "Reintentar",
      developmentTitle: "Dashboard en desarrollo",
      developmentDesc: "Esta sección estará disponible próximamente con análisis avanzados.",
      dashboardId: "ID del Dashboard"
    },
    // OSINT Intelligence
    osint: {
      intelligenceCenter: "OSINT Intelligence Center",
      intelligenceDesc: "Inteligencia accionable de fuentes abiertas en tiempo real",
      realtime: "En Vivo",
      lastUpdate: "Última actualización: hace 2 min",
      refresh: "Actualizar",
      export: "Exportar",
      timeframes: {
        "24h": "24h",
        "7days": "7 días",
        "30days": "30 días", 
        "90days": "90 días"
      },
      metrics: {
        totalMentions: "Menciones Totales",
        sentimentScore: "Sentiment Score",
        reachEstimate: "Alcance Estimado",
        engagementRate: "Engagement Rate",
        criticalAlerts: "Alertas Críticas", 
        trendingTopics: "Trending Topics"
      },
      dataSources: "Fuentes de Datos",
      sourcesLegend: "● Activo ○ Inactivo",
      sources: {
        social: "Redes Sociales",
        news: "Medios Digitales",
        forums: "Foros y Blogs",
        review: "Sitios de Reseñas",
        video: "Plataformas Video"
      },
      mentions: "menciones",
      sentimentAnalysis: "Análisis de Sentimiento",
      sentimentTypes: {
        positive: "Positivo",
        neutral: "Neutral", 
        negative: "Negativo"
      },
      trending: "Trending Topics",
      trendingFilters: {
        all: "Todo",
        positive: "Positivo",
        negative: "Negativo"
      },
      geographicDist: "Distribución Geográfica",
      countries: {
        spain: "España",
        mexico: "México",
        argentina: "Argentina",
        colombia: "Colombia",
        chile: "Chile"
      },
      criticalAlerts: "Alertas Críticas",
      alertTypes: {
        negative_spike: "Pico de menciones negativas detectado",
        competitor_mention: "Comparación con competidor detectada",
        viral_content: "Contenido viral positivo sobre la marca"
      },
      intelligenceReports: "Informes de Inteligencia",
      reportTypes: {
        competitive: "Análisis Competitivo Semanal",
        reputation: "Detección de Crisis Reputacional",
        opportunity: "Oportunidades de Engagement"
      },
      insights: "insights",
      confidence: "confianza",
      viewReport: "Ver Completo"
    },
    // Footer
    footer: {
      tagline1: "Simplificamos los datos.",
      tagline2: "Multiplicamos las decisiones.",
      platformTitle: "Plataforma de Comunicación Inteligente",
      platformDescription: "Herramientas avanzadas para análisis de campañas, gestión de contactos y generación de reportes detallados que impulsan tu estrategia de comunicación.",
      analyticsFeature: "Análisis Avanzado",
      analyticsDesc: "Métricas en tiempo real y análisis predictivo para optimizar tus campañas.",
      contactsFeature: "Gestión de Contactos",
      contactsDesc: "Base de datos inteligente con segmentación automática y seguimiento personalizado.",
      campaignsFeature: "Campañas Efectivas",
      campaignsDesc: "Creación y gestión de campañas multicanales con automatización inteligente.",
      reportsFeature: "Reportes Detallados",
      reportsDesc: "Informes completos con insights accionables y visualizaciones interactivas.",
      quickLinks: "Enlaces Rápidos",
      support: "Soporte",
      dashboard: "Panel Principal",
      analytics: "Analíticas",
      campaigns: "Campañas",
      reports: "Informes",
      help: "Ayuda",
      documentation: "Documentación",
      contact: "Contacto",
      privacy: "Privacidad",
      copyright: "© Todos los derechos por Amb Tu"
    },
    // Footer
    footer: {
      tagline1: "Simplificamos los datos.",
      tagline2: "Multiplicamos las decisiones.",
      platformTitle: "Plataforma de Comunicación Inteligente",
      platformDescription: "Herramientas avanzadas para análisis de campañas, gestión de contactos y generación de reportes detallados que impulsan tu estrategia de comunicación.",
      analyticsFeature: "Análisis Avanzado",
      analyticsDesc: "Métricas en tiempo real y análisis predictivo para optimizar tus campañas.",
      contactsFeature: "Gestión de Contactos",
      contactsDesc: "Base de datos inteligente con segmentación automática y seguimiento personalizado.",
      campaignsFeature: "Campañas Efectivas",
      campaignsDesc: "Creación y gestión de campañas multicanales con automatización inteligente.",
      reportsFeature: "Reportes Detallados",
      reportsDesc: "Informes completos con insights accionables y visualizaciones interactivas.",
      quickLinks: "Enlaces Rápidos",
      support: "Soporte",
      dashboard: "Panel Principal",
      analytics: "Analíticas",
      campaigns: "Campañas",
      reports: "Informes",
      help: "Ayuda",
      documentation: "Documentación",
      contact: "Contacto",
      privacy: "Privacidad",
      copyright: "© Todos los derechos por Amb Tu"
    },
    // Common
    common: {
      hours: "horas",
      minutes: "min",
      ago: "hace",
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      save: "Guardar",
      cancel: "Cancelar",
      close: "Cerrar",
      search: "Buscar",
      filter: "Filtro",
      all: "Todos",
      active: "Activo",
      inactive: "Inactivo",
      yes: "Sí", 
      no: "No"
    }
  },
  ca: {
    // Navigation
    nav: {
      conversational: "Conversacional",
      reputational: "Monitorització Reputacional",
      tools: "Eines",
      analytics: "Analítiques",
      campaigns: "Campanyes",
      conversations: "Converses", 
      reports: "Informes",
      osint: "Monitor OSINT",
      settings: "Configuració"
    },
    // Analytics Panel
    analytics: {
      title: "Analítiques Outbound",
      subtitle: "Tota la informació amb un clic",
      description: "Realitzeu un seguiment, gestioneu els vostres clients i la seva activitat",
      lastDays: "Últims 30 dies",
      totalCalls: "Total Trucades",
      attendedCalls: "Ateses", 
      abandonedCalls: "Abandonades",
      avgDuration: "Durada Mitjana",
      callDistribution: "Distribució de resultats de trucades",
      callEvolution: "Evolució de trucades",
      campaignResults: "Resultats de campanyes",
      contracts: "Contractacions",
      occupancy: "Ocupació",
      tma: "TMA",
      tme: "TME",
      confirmed: "Confirmada",
      modified: "Modificada",
      notConfirmed: "No confirmada",
      cancelled: "Cancel·lada",
      dashboardReport: "Informe Detallat - Anàlisi Avançada",
      dashboardPlaceholder: "Dashboards interactius amb anàlisi avançada",
      // Tab system labels
      tabs: {
        performanceMetrics: "Mètriques de Rendiment",
        conversationAnalytics: "Anàlisi Conversacional",
        realTimeDashboard: "Dashboard en Temps Real", 
        kpiOverview: "Resum de KPIs",
        performanceDesc: "Mètriques principals de rendiment i productivitat",
        conversationDesc: "Anàlisi detallada de converses i transcripcions",
        realTimeDesc: "Monitoratge en temps real d'activitat i trucades",
        kpiDesc: "Indicadors clau de rendiment i objectius"
      }
    },
    // Campaigns Panel
    campaigns: {
      title: "Les meves campanyes",
      newCampaign: "Nova campanya",
      search: "Cercar",
      state: "Estat",
      clearFilters: "Esborrar filtres",
      phoneNumber: "Número de telèfon",
      campaignResult: "Resultat campanya",
      contacts: "Contactes",
      calls: "Trucades",
      creationDate: "Data creació",
      status: "Estat",
      draft: "Esborrany",
      paused: "Pausada",
      completed: "Realitzada",
      export: "Exportar",
      // Campaign Management
      management: {
        title: "Gestió de Campanyes Conversacionals",
        subtitle: "Administra campanyes de voicebots, chatbots i agents humans per a diferents indústries"
      },
      types: {
        sales: "Vendes",
        support: "Atenció al Client",
        collections: "Cobraments", 
        surveys: "Enquestes",
        appointments: "Cites",
        retention: "Retenció"
      },
      industries: {
        banking: "Banca i Finances",
        healthcare: "Salut",
        retail: "Retail",
        telecom: "Telecomunicacions",
        insurance: "Assegurances", 
        automotive: "Automotriu"
      },
      channels: {
        voicebot: "VoiceBot",
        chatbot: "ChatBot", 
        human: "Agents Humans",
        hybrid: "Híbrid"
      }
    },
    // Conversations Panel
    conversations: {
      title: "Converses",
      all: "Tots",
      confirmed: "Confirmat",
      date: "Data",
      time: "Hora",
      phoneNumber: "Número de telèfon",
      selectConversation: "Selecciona una conversa per veure els detalls",
      back: "Tornar",
      contactInfo: "Veure informació de contacte",
      alternativeContact: "Contacte alternatiu",
      fixedField: "Camp fix",
      callAttempts: "Intents de trucada",
      callOrigin: "Origen de trucada",
      agentVoice: "Veu d'agent",
      campaign: "Campanya",
      callState: "Estat",
      result: "Resultat",
      duration: "Durada",
      hungUpBy: "Penjat per",
      callSummary: "Resum de trucada",
      callResults: "Resultats de trucada",
      alternativeTime: "Hora alternativa",
      deliveryDate: "Data de lliurament",
      transcription: "Transcripció",
      thinking: "Pensament",
      conversation: "Conversa",
      agent: "Agente Virtual",
      customer: "Client"
    },
    // Reports Panel  
    reports: {
      title: "Vendes Madrid",
      finished: "Finalitzat el 23 de gener de 2025",
      download: "Descarregar",
      salesDistribution: "Distribució de les teves vendes",
      scheduled: "Programada",
      interested: "Interessat",
      pending: "Pendent",
      rejected: "Rebutjada",
      evaluator: "Avaluador de Qualitat",
      evaluatorDesc: "Evalua converses amb comprensió real. Qualitat basada en comprensió.",
      globalRating: "Valoració global",
      optimalPerformance: "El teu agent està tenint un rendiment òptim en totes les àrees clau.",
      customerSatisfaction: "Satisfacció del client",
      callCompliance: "Compliment de trucada",
      responseComplexity: "Complexitat de respostes",
      clarityIndex: "Índex de claredat",
      veryGood: "Molt bo",
      generalSummary: "Resum general",
      totalContacts: "Total contactes",
      callAttempts: "Intents de trucada",
      totalConsumption: "Consum total",
      campaignCost: "Cost de campanya",
      callBreakdown: "Així van ser les teves trucades",
      completed: "Realitzades",
      errors: "Errònies",
      returned: "Retornades",
      voicemails: "Bústies de veu",
      rescheduled: "Reprogramades",
      detailedAnalysis: "Anàlisi Detallada - Informes Avançats",
      dashboardPlaceholder: "Informes detallats amb mètriques avançades",
      // Tab system labels for reports
      tabs: {
        campaignReports: "Informes de Campanyes",
        osintReports: "Informes OSINT",
        customReports: "Informes Personalitzats",
        performanceReports: "Informes de Rendiment",
        campaignDesc: "Anàlisi detallada del rendiment de campanyes",
        osintDesc: "Informes de monitorització i anàlisi reputacional",
        customDesc: "Informes personalitzats i configurables",
        performanceDesc: "Mètriques de rendiment i KPIs principals"
      }
    },
    // OSINT Panel
    osint: {
      title: "Monitor OSINT",
      description: "Monitorització de fonts obertes i anàlisi de reputació",
      filters: "Filtres",
      newSearch: "Nova cerca",
      overview: "Resum",
      mentions: "Mencions",
      alerts: "Alertes",
      competitors: "Competència",
      totalMentions: "Mencions Total",
      positiveSentiment: "Sentiment Positiu",
      activeAlerts: "Alertes Actives",
      monitoredSources: "Fonts Monitoritzades",
      mentionsByPlatform: "Mencions per Plataforma",
      recentMentions: "Mencions Recents",
      sentiment: "Sentiment",
      interactions: "interaccions",
      allMentions: "Totes les Mencions",
      searchMentions: "Cercar mencions...",
      socialMonitoring: "Aquesta secció es connectarà amb APIs de monitorització de xarxes socials",
      keywordAlerts: "Alertes de Paraules Clau",
      seeDetails: "Veure detalls",
      competitorAnalysis: "Anàlisi de Competència",
      positive: "positiu",
      negative: "negatiu",
      neutral: "neutral"
    },
    // Settings Panel
    settings: {
      title: "Configuració del Sistema",
      description: "Administra el teu compte, notificacions, seguretat i integracions",
      sections: {
        account: "Compte d'Usuari",
        notifications: "Notificacions", 
        security: "Seguretat",
        integrations: "Integracions",
        dashboards: "Dashboards",
        appearance: "Aparença",
        export: "Exportar Dades"
      },
      account: {
        title: "Configuració de Compte",
        fullName: "Nom Complet",
        email: "Email",
        phone: "Telèfon",
        role: "Rol",
        department: "Departament",
        roles: {
          administrator: "Administrador",
          manager: "Manager",
          agent: "Agent",
          analyst: "Analista"
        },
        save: "Guardar Canvis"
      },
      notifications: {
        title: "Configuració de Notificacions",
        channels: "Canals de Notificació",
        types: "Tipus de Notificació",
        email: "Email",
        emailDesc: "Rebre notificacions per correu electrònic",
        sms: "SMS",
        smsDesc: "Rebre notificacions per missatge de text",
        push: "Push",
        pushDesc: "Notificacions push al navegador",
        campaigns: "Campanyes",
        campaignsDesc: "Notificacions sobre estat de campanyes",
        reports: "Informes",
        reportsDesc: "Notificacions sobre nous informes",
        alerts: "Alertes",
        alertsDesc: "Alertes crítiques i de seguretat",
        save: "Guardar Notificacions"
      },
      security: {
        title: "Configuració de Seguretat",
        changePassword: "Canviar Contrasenya",
        currentPassword: "Contrasenya Actual",
        newPassword: "Nova Contrasenya",
        confirmPassword: "Confirmar Nova Contrasenya",
        twoFactor: "Autenticació de Dos Factors",
        twoFactorDisabled: "2FA Desactivat",
        twoFactorDesc: "Afegeix una capa extra de seguretat al teu compte",
        activate2FA: "Activar 2FA",
        activeSessions: "Sessions Actives",
        currentBrowser: "Navegador Actual",
        currentDevice: "Chrome a Windows • Activa ara",
        mobileDevice: "Dispositiu Mòbil",
        mobileDesc: "Safari a iOS • Fa 2 hores",
        closeSession: "Tancar Sessió",
        current: "Actual"
      },
      integrations: {
        title: "Integracions i APIs",
        apiKey: "API Key Amb Tu",
        apiKeyDesc: "Clau d'API per integracions externes",
        copy: "Copiar",
        regenerate: "Regenerar",
        webhook: "Webhook URL",
        webhookDesc: "Endpoint per rebre notificacions",
        externalDb: "Base de Dades Externa",
        externalDbDesc: "Connexió al teu CRM o base de dades",
        disconnected: "Desconnectat",
        configure: "Configurar"
      },
      export: {
        title: "Exportar i Backup de Dades",
        exportData: "Exportar Dades",
        campaignData: "Dades de Campanyes",
        campaignDataDesc: "Exportar totes les campanyes i els seus resultats",
        analytics: "Anàlisi i Mètriques",
        analyticsDesc: "Exportar dashboards i anàlisi complets",
        fullConfig: "Configuració Completa",
        fullConfigDesc: "Backup complet de tota la configuració",
        exportCsv: "Exportar CSV",
        exportPdf: "Exportar PDF",
        exportJson: "Exportar JSON",
        importConfig: "Importar Configuració",
        importDesc: "Arrossega un fitxer JSON o fes clic per seleccionar",
        selectFile: "Seleccionar Fitxer"
      }
    },
    // Period Options
    periods: {
      last7days: "Últims 7 dies",
      last30days: "Últims 30 dies", 
      last90days: "Últims 90 dies",
      thisMonth: "Aquest mes",
      lastMonth: "Mes anterior",
      thisYear: "Aquest any"
    },
    // Analytics Types
    analyticsTypes: {
      outbound: "Outbound",
      inbound: "Inbound", 
      outboundDesc: "Campanyes Sortints",
      inboundDesc: "Atenció Entrant"
    },
    // Table Headers
    table: {
      answered: "Contestats",
      notAnswered: "No contestats",
      detailOf: "Veure detalls de"
    },
    // Campaign Management
    campaignMgmt: {
      title: "Gestió de Campanyes Conversacionals",
      subtitle: "Administra campanyes de voicebots, chatbots i agents humans per a diferents indústries",
      statsActive: "Campanyes Actives",
      statsContacts: "Contactes Totals",
      statsSuccess: "Taxa Èxit Promig",
      statsRevenue: "Ingressos Generats",
      filters: "Filtres",
      allIndustries: "Totes les indústries",
      allTypes: "Tots els tipus",
      tabAll: "Totes",
      tabActive: "Actives",
      tabPaused: "Pausades", 
      tabCompleted: "Completades",
      progress: "Progrés",
      totalContacts: "Contactes Totals",
      contactsCompleted: "Contactes Realitzats",
      successRate: "Taxa d'Èxit",
      avgDuration: "Durada Promig",
      revenueGenerated: "Ingressos Generats",
      pauseCampaign: "Pausar",
      resumeCampaign: "Continuar",
      viewDetails: "Veure Detalls",
      types: {
        sales: "Vendes",
        support: "Atenció al Client",
        collections: "Cobraments", 
        surveys: "Enquestes",
        appointments: "Cites",
        retention: "Retenció"
      },
      industries: {
        banking: "Banca i Finances",
        healthcare: "Salut",
        retail: "Retail",
        telecom: "Telecomunicacions",
        insurance: "Assegurances",
        automotive: "Automotriu"
      },
      channels: {
        voicebot: "VoiceBot",
        chatbot: "ChatBot",
        human: "Agents Humans",
        hybrid: "Híbrid"
      }
    },
    // Campaign Details Modal
    campaignDetails: {
      edit: "Editar",
      duplicate: "Duplicar",
      export: "Exportar",
      totalContacts: "Contactes Totals",
      contactsCompleted: "Contactes Realitzats", 
      successRate: "Taxa d'Èxit",
      avgDuration: "Durada Promig",
      revenueGenerated: "Ingressos Generats",
      pauseCampaign: "Pausar Campanya",
      resumeCampaign: "Reprendre Campanya",
      configure: "Configurar",
      refreshData: "Actualitzar Dades",
      detailedAnalysis: "Anàlisi Detallada",
      interactiveDashboards: "Dashboards interactius específics per aquesta campanya",
      status: {
        active: "Activa",
        paused: "Pausada",
        completed: "Completada"
      }
    },
    // Tab System
    tabSystem: {
      refresh: "Actualitzar",
      openNew: "Obrir en nova finestra",
      fullscreen: "Pantalla completa",
      loading: "Carregant dashboard...",
      error: "Error al carregar el dashboard",
      errorDesc: "No s'ha pogut carregar el dashboard des de:",
      retry: "Reintentar",
      developmentTitle: "Dashboard en desenvolupament",
      developmentDesc: "Aquesta secció estarà disponible properament amb anàlisi avançades.",
      dashboardId: "ID del Dashboard"
    },
    // OSINT Intelligence
    osint: {
      intelligenceCenter: "OSINT Intelligence Center",
      intelligenceDesc: "Intel·ligència accionable de fonts obertes en temps real",
      realtime: "En Viu",
      lastUpdate: "Última actualització: fa 2 min",
      refresh: "Actualitzar",
      export: "Exportar",
      timeframes: {
        "24h": "24h",
        "7days": "7 dies",
        "30days": "30 dies", 
        "90days": "90 dies"
      },
      metrics: {
        totalMentions: "Mencions Totals",
        sentimentScore: "Sentiment Score",
        reachEstimate: "Abast Estimat",
        engagementRate: "Taxa d'Engagement",
        criticalAlerts: "Alertes Crítiques", 
        trendingTopics: "Trending Topics"
      },
      dataSources: "Fonts de Dades",
      sourcesLegend: "● Actiu ○ Inactiu",
      sources: {
        social: "Xarxes Socials",
        news: "Mitjans Digitals",
        forums: "Fòrums i Blogs",
        review: "Llocs de Ressenyes",
        video: "Plataformes Vídeo"
      },
      mentions: "mencions",
      sentimentAnalysis: "Anàlisi de Sentiment",
      sentimentTypes: {
        positive: "Positiu",
        neutral: "Neutral", 
        negative: "Negatiu"
      },
      trending: "Trending Topics",
      trendingFilters: {
        all: "Tot",
        positive: "Positiu",
        negative: "Negatiu"
      },
      geographicDist: "Distribució Geogràfica",
      countries: {
        spain: "Espanya",
        mexico: "Mèxic",
        argentina: "Argentina",
        colombia: "Colòmbia",
        chile: "Xile"
      },
      criticalAlerts: "Alertes Crítiques",
      alertTypes: {
        negative_spike: "Pic de mencions negatives detectat",
        competitor_mention: "Comparació amb competidor detectada",
        viral_content: "Contingut viral positiu sobre la marca"
      },
      intelligenceReports: "Informes d'Intel·ligència",
      reportTypes: {
        competitive: "Anàlisi Competitiva Setmanal",
        reputation: "Detecció de Crisis Reputacional",
        opportunity: "Oportunitats d'Engagement"
      },
      insights: "insights",
      confidence: "confiança",
      viewReport: "Veure Complet"
    },
    // Footer
    footer: {
      tagline1: "Simplifiquem les dades.",
      tagline2: "Multipliquem les decisions.",
      login: "Iniciar Sessió",
      newsletterTitle: "Mantén-te Connectat",
      newsletterText: "Mantén-te actualitzat amb les últimes notícies, promocions i ofertes exclusives.",
      emailPlaceholder: "el.teu@email.com",
      submit: "Enviar",
      submitting: "Enviant...",
      subscriptionSuccess: "Subscripció exitosa! Gràcies per unir-te.",
      social: "Social",
      pages: "Pàgines",
      info: "Informació",
      home: "Inici",
      about: "Sobre nosaltres",
      properties: "Propietats",
      contact: "Contacte",
      privacy: "Política de Privacitat",
      copyright: "© Tots els drets per Amb Tu"
    },
    // Common
    common: {
      hours: "hores",
      minutes: "min",
      ago: "fa",
      loading: "Carregant...",
      error: "Error",
      success: "Èxit",
      save: "Guardar",
      cancel: "Cancel·lar",
      close: "Tancar",
      search: "Cercar",
      filter: "Filtre",
      all: "Tots",
      active: "Actiu",
      inactive: "Inactiu",
      yes: "Sí", 
      no: "No"
    }
  },
  en: {
    // Navigation
    nav: {
      conversational: "Conversational",
      reputational: "Reputation Monitoring",
      tools: "Tools",
      analytics: "Analytics",
      campaigns: "Campaigns",
      conversations: "Conversations",
      reports: "Reports",
      osint: "OSINT Monitor",
      settings: "Settings"
    },
    // Analytics Panel
    analytics: {
      title: "Outbound Analytics",
      subtitle: "All information at a click",
      description: "Track, manage your customers and their activity",
      lastDays: "Last 30 days",
      totalCalls: "Total Calls",
      attendedCalls: "Attended",
      abandonedCalls: "Abandoned",
      avgDuration: "Average Duration",
      callDistribution: "Call results distribution",
      callEvolution: "Call evolution",
      campaignResults: "Campaign results",
      contracts: "Contracts",
      occupancy: "Occupancy",
      tma: "AHT",
      tme: "ASA",
      confirmed: "Confirmed",
      modified: "Modified",
      notConfirmed: "Not confirmed",
      cancelled: "Cancelled",
      dashboardReport: "Detailed Report - Advanced Analytics",
      dashboardPlaceholder: "Interactive dashboards with advanced analytics",
      // Tab system labels
      tabs: {
        performanceMetrics: "Performance Metrics",
        conversationAnalytics: "Conversation Analytics",
        realTimeDashboard: "Real-time Dashboard", 
        kpiOverview: "KPI Overview",
        performanceDesc: "Key performance and productivity metrics",
        conversationDesc: "Detailed analysis of conversations and transcriptions",
        realTimeDesc: "Real-time monitoring of activity and calls",
        kpiDesc: "Key performance indicators and objectives"
      }
    },
    // Campaigns Panel
    campaigns: {
      title: "My campaigns",
      newCampaign: "New campaign",
      search: "Search",
      state: "State",
      clearFilters: "Clear filters",
      phoneNumber: "Phone number",
      campaignResult: "Campaign result",
      contacts: "Contacts",
      calls: "Calls",
      creationDate: "Creation date",
      status: "Status",
      draft: "Draft",
      paused: "Paused",
      completed: "Completed",
      export: "Export",
      // Campaign Management
      management: {
        title: "Conversational Campaign Management",
        subtitle: "Manage voicebot, chatbot and human agent campaigns across different industries"
      },
      types: {
        sales: "Sales",
        support: "Customer Support",
        collections: "Collections",
        surveys: "Surveys", 
        appointments: "Appointments",
        retention: "Retention"
      },
      industries: {
        banking: "Banking & Finance",
        healthcare: "Healthcare",  
        retail: "Retail",
        telecom: "Telecommunications",
        insurance: "Insurance",
        automotive: "Automotive"
      },
      channels: {
        voicebot: "VoiceBot",
        chatbot: "ChatBot",
        human: "Human Agents", 
        hybrid: "Hybrid"
      }
    },
    // Conversations Panel
    conversations: {
      title: "Conversations",
      all: "All",
      confirmed: "Confirmed",
      date: "Date",
      time: "Time",
      phoneNumber: "Phone number",
      selectConversation: "Select a conversation to view details",
      back: "Back",
      contactInfo: "View contact information",
      alternativeContact: "Alternative contact",
      fixedField: "Fixed field",
      callAttempts: "Call attempts",
      callOrigin: "Call origin",
      agentVoice: "Agent voice",
      campaign: "Campaign",
      callState: "State",
      result: "Result",
      duration: "Duration",
      hungUpBy: "Hung up by",
      callSummary: "Call summary",
      callResults: "Call results",
      alternativeTime: "Alternative time",
      deliveryDate: "Delivery date",
      transcription: "Transcription",
      thinking: "Thinking",
      conversation: "Conversation",
      agent: "Agente Virtual",
      customer: "Customer"
    },
    // Reports Panel
    reports: {
      title: "Madrid Sales",
      finished: "Finished on January 23, 2025",
      download: "Download",
      salesDistribution: "Your sales distribution",
      scheduled: "Scheduled",
      interested: "Interested",
      pending: "Pending",
      rejected: "Rejected",
      evaluator: "Quality Evaluator",
      evaluatorDesc: "Evaluates conversations with real understanding. Quality based on comprehension.",
      globalRating: "Global rating",
      optimalPerformance: "Your agent is performing optimally in all key areas.",
      customerSatisfaction: "Customer satisfaction",
      callCompliance: "Call compliance",
      responseComplexity: "Response complexity",
      clarityIndex: "Clarity index",
      veryGood: "Very good",
      generalSummary: "General summary",
      totalContacts: "Total contacts",
      callAttempts: "Call attempts",
      totalConsumption: "Total consumption",
      campaignCost: "Campaign cost",
      callBreakdown: "This is how your calls went",
      completed: "Completed",
      errors: "Errors",
      returned: "Returned",
      voicemails: "Voicemails",
      rescheduled: "Rescheduled",
      detailedAnalysis: "Detailed Analysis - Advanced Reports",
      dashboardPlaceholder: "Detailed reports with advanced metrics",
      // Tab system labels for reports
      tabs: {
        campaignReports: "Campaign Reports",
        osintReports: "OSINT Reports",
        customReports: "Custom Reports",
        performanceReports: "Performance Reports",
        campaignDesc: "Detailed campaign performance analysis",
        osintDesc: "Monitoring and reputation analysis reports",
        customDesc: "Customizable and configurable reports",
        performanceDesc: "Performance metrics and key KPIs"
      }
    },
    // OSINT Panel
    osint: {
      title: "OSINT Monitor",
      description: "Open source monitoring and reputation analysis",
      filters: "Filters",
      newSearch: "New search",
      overview: "Overview",
      mentions: "Mentions",
      alerts: "Alerts",
      competitors: "Competitors",
      totalMentions: "Total Mentions",
      positiveSentiment: "Positive Sentiment",
      activeAlerts: "Active Alerts", 
      monitoredSources: "Monitored Sources",
      mentionsByPlatform: "Mentions by Platform",
      recentMentions: "Recent Mentions",
      sentiment: "Sentiment",
      interactions: "interactions",
      allMentions: "All Mentions",
      searchMentions: "Search mentions...",
      socialMonitoring: "This section will connect with social media monitoring APIs",
      keywordAlerts: "Keyword Alerts",
      seeDetails: "See details",
      competitorAnalysis: "Competitor Analysis",
      positive: "positive",
      negative: "negative",
      neutral: "neutral"
    },
    // Settings Panel
    settings: {
      title: "System Configuration",
      description: "Manage your account, notifications, security and integrations",
      sections: {
        account: "User Account",
        notifications: "Notifications", 
        security: "Security",
        integrations: "Integrations",
        dashboards: "Dashboards",
        appearance: "Appearance",
        export: "Export Data"
      },
      account: {
        title: "Account Configuration",
        fullName: "Full Name",
        email: "Email",
        phone: "Phone",
        role: "Role",
        department: "Department",
        roles: {
          administrator: "Administrator",
          manager: "Manager",
          agent: "Agent",
          analyst: "Analyst"
        },
        save: "Save Changes"
      },
      notifications: {
        title: "Notification Settings",
        channels: "Notification Channels",
        types: "Notification Types",
        email: "Email",
        emailDesc: "Receive notifications via email",
        sms: "SMS",
        smsDesc: "Receive notifications via text message",
        push: "Push",
        pushDesc: "Browser push notifications",
        campaigns: "Campaigns",
        campaignsDesc: "Notifications about campaign status",
        reports: "Reports",
        reportsDesc: "Notifications about new reports",
        alerts: "Alerts",
        alertsDesc: "Critical and security alerts",
        save: "Save Notifications"
      },
      security: {
        title: "Security Configuration",
        changePassword: "Change Password",
        currentPassword: "Current Password",
        newPassword: "New Password",
        confirmPassword: "Confirm New Password",
        twoFactor: "Two-Factor Authentication",
        twoFactorDisabled: "2FA Disabled",
        twoFactorDesc: "Add an extra layer of security to your account",
        activate2FA: "Enable 2FA",
        activeSessions: "Active Sessions",
        currentBrowser: "Current Browser",
        currentDevice: "Chrome on Windows • Active now",
        mobileDevice: "Mobile Device",
        mobileDesc: "Safari on iOS • 2 hours ago",
        closeSession: "Sign Out",
        current: "Current"
      },
      integrations: {
        title: "Integrations and APIs",
        apiKey: "Amb Tu API Key",
        apiKeyDesc: "API key for external integrations",
        copy: "Copy",
        regenerate: "Regenerate",
        webhook: "Webhook URL",
        webhookDesc: "Endpoint to receive notifications",
        externalDb: "External Database",
        externalDbDesc: "Connection to your CRM or database",
        disconnected: "Disconnected",
        configure: "Configure"
      },
      export: {
        title: "Export and Data Backup",
        exportData: "Export Data",
        campaignData: "Campaign Data",
        campaignDataDesc: "Export all campaigns and their results",
        analytics: "Analytics and Metrics",
        analyticsDesc: "Export dashboards and complete analysis",
        fullConfig: "Complete Configuration",
        fullConfigDesc: "Complete backup of all configuration",
        exportCsv: "Export CSV",
        exportPdf: "Export PDF",
        exportJson: "Export JSON",
        importConfig: "Import Configuration",
        importDesc: "Drag a JSON file or click to select",
        selectFile: "Select File"
      }
    },
    // Period Options
    periods: {
      last7days: "Last 7 days",
      last30days: "Last 30 days", 
      last90days: "Last 90 days",
      thisMonth: "This month",
      lastMonth: "Last month",
      thisYear: "This year"
    },
    // Analytics Types
    analyticsTypes: {
      outbound: "Outbound",
      inbound: "Inbound", 
      outboundDesc: "Outbound Campaigns",
      inboundDesc: "Inbound Support"
    },
    // Table Headers
    table: {
      answered: "Answered",
      notAnswered: "Not answered",
      detailOf: "View details of"
    },
    // Campaign Management
    campaignMgmt: {
      title: "Conversational Campaign Management",
      subtitle: "Manage voicebot, chatbot and human agent campaigns across different industries",
      statsActive: "Active Campaigns",
      statsContacts: "Total Contacts",
      statsSuccess: "Average Success Rate",
      statsRevenue: "Generated Revenue",
      filters: "Filters",
      allIndustries: "All industries",
      allTypes: "All types",
      tabAll: "All",
      tabActive: "Active",
      tabPaused: "Paused", 
      tabCompleted: "Completed",
      progress: "Progress",
      totalContacts: "Total Contacts",
      contactsCompleted: "Contacts Completed",
      successRate: "Success Rate",
      avgDuration: "Average Duration",
      revenueGenerated: "Generated Revenue",
      pauseCampaign: "Pause",
      resumeCampaign: "Resume",
      viewDetails: "View Details",
      types: {
        sales: "Sales",
        support: "Customer Support",
        collections: "Collections", 
        surveys: "Surveys",
        appointments: "Appointments",
        retention: "Retention"
      },
      industries: {
        banking: "Banking & Finance",
        healthcare: "Healthcare",
        retail: "Retail",
        telecom: "Telecommunications",
        insurance: "Insurance",
        automotive: "Automotive"
      },
      channels: {
        voicebot: "VoiceBot",
        chatbot: "ChatBot",
        human: "Human Agents",
        hybrid: "Hybrid"
      }
    },
    // Campaign Details Modal
    campaignDetails: {
      edit: "Edit",
      duplicate: "Duplicate",
      export: "Export",
      totalContacts: "Total Contacts",
      contactsCompleted: "Contacts Completed", 
      successRate: "Success Rate",
      avgDuration: "Average Duration",
      revenueGenerated: "Generated Revenue",
      pauseCampaign: "Pause Campaign",
      resumeCampaign: "Resume Campaign",
      configure: "Configure",
      refreshData: "Refresh Data",
      detailedAnalysis: "Detailed Analysis",
      interactiveDashboards: "Interactive dashboards specific to this campaign",
      status: {
        active: "Active",
        paused: "Paused",
        completed: "Completed"
      }
    },
    // Tab System
    tabSystem: {
      refresh: "Refresh",
      openNew: "Open in new window",
      fullscreen: "Full screen",
      loading: "Loading dashboard...",
      error: "Error loading dashboard",
      errorDesc: "Could not load dashboard from:",
      retry: "Retry",
      developmentTitle: "Dashboard in development",
      developmentDesc: "This section will be available soon with advanced analytics.",
      dashboardId: "Dashboard ID"
    },
    // OSINT Intelligence
    osint: {
      intelligenceCenter: "OSINT Intelligence Center",
      intelligenceDesc: "Actionable intelligence from open sources in real time",
      realtime: "Live",
      lastUpdate: "Last update: 2 min ago",
      refresh: "Refresh",
      export: "Export",
      timeframes: {
        "24h": "24h",
        "7days": "7 days",
        "30days": "30 days", 
        "90days": "90 days"
      },
      metrics: {
        totalMentions: "Total Mentions",
        sentimentScore: "Sentiment Score",
        reachEstimate: "Estimated Reach",
        engagementRate: "Engagement Rate",
        criticalAlerts: "Critical Alerts", 
        trendingTopics: "Trending Topics"
      },
      dataSources: "Data Sources",
      sourcesLegend: "● Active ○ Inactive",
      sources: {
        social: "Social Networks",
        news: "Digital Media",
        forums: "Forums and Blogs",
        review: "Review Sites",
        video: "Video Platforms"
      },
      mentions: "mentions",
      sentimentAnalysis: "Sentiment Analysis",
      sentimentTypes: {
        positive: "Positive",
        neutral: "Neutral", 
        negative: "Negative"
      },
      trending: "Trending Topics",
      trendingFilters: {
        all: "All",
        positive: "Positive",
        negative: "Negative"
      },
      geographicDist: "Geographic Distribution",
      countries: {
        spain: "Spain",
        mexico: "Mexico",
        argentina: "Argentina",
        colombia: "Colombia",
        chile: "Chile"
      },
      criticalAlerts: "Critical Alerts",
      alertTypes: {
        negative_spike: "Negative mentions spike detected",
        competitor_mention: "Competitor comparison detected",
        viral_content: "Positive viral content about the brand"
      },
      intelligenceReports: "Intelligence Reports",
      reportTypes: {
        competitive: "Weekly Competitive Analysis",
        reputation: "Reputation Crisis Detection",
        opportunity: "Engagement Opportunities"
      },
      insights: "insights",
      confidence: "confidence",
      viewReport: "View Complete"
    },
    // Common
    common: {
      hours: "hours",
      minutes: "min",
      ago: "ago",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      save: "Save",
      cancel: "Cancel",
      close: "Close",
      search: "Search",
      filter: "Filter",
      all: "All",
      active: "Active",
      inactive: "Inactive",
      yes: "Yes", 
      no: "No"
    }
  },
  fr: {
    // Navigation
    nav: {
      conversational: "Conversationnel",
      reputational: "Surveillance Réputationnelle",
      tools: "Outils",
      analytics: "Analytiques",
      campaigns: "Campagnes",
      conversations: "Conversations",
      reports: "Rapports",
      osint: "Moniteur OSINT",
      settings: "Configuration"
    },
    // Analytics Panel
    analytics: {
      title: "Analytiques Outbound",
      subtitle: "Toutes les informations en un clic",
      description: "Suivez, gérez vos clients et leur activité",
      lastDays: "30 derniers jours",
      totalCalls: "Total Appels",
      attendedCalls: "Répondus",
      abandonedCalls: "Abandonnés",
      avgDuration: "Durée Moyenne",
      callDistribution: "Distribution des résultats d'appels",
      callEvolution: "Évolution des appels",
      campaignResults: "Résultats de campagnes",
      confirmed: "Confirmé",
      modified: "Modifié",
      notConfirmed: "Non confirmé",
      cancelled: "Annulé",
      dashboardReport: "Rapport Détaillé - Analytiques Avancées",
      dashboardPlaceholder: "Tableaux de bord interactifs avec analytiques avancées",
      // Tab system labels
      tabs: {
        performanceMetrics: "Métriques de Performance",
        conversationAnalytics: "Analytiques Conversationnelles",
        realTimeDashboard: "Tableau de Bord Temps Réel",
        kpiOverview: "Aperçu des KPI",
        performanceDesc: "Métriques clés de performance et productivité",
        conversationDesc: "Analyse détaillée des conversations et transcriptions",
        realTimeDesc: "Surveillance en temps réel d'activité et appels",
        kpiDesc: "Indicateurs clés de performance et objectifs"
      }
    },
    // Campaigns Panel
    campaigns: {
      title: "Mes campagnes",
      newCampaign: "Nouvelle campagne",
      search: "Rechercher",
      state: "État",
      clearFilters: "Effacer les filtres",
      phoneNumber: "Numéro de téléphone",
      campaignResult: "Résultat campagne",
      contacts: "Contacts",
      calls: "Appels",
      creationDate: "Date de création",
      status: "Statut",
      draft: "Brouillon",
      paused: "Pausée",
      completed: "Terminée",
      export: "Exporter",
      // Campaign Management
      management: {
        title: "Gestion des Campagnes Conversationnelles",
        subtitle: "Gérez les campagnes de voicebots, chatbots et agents humains dans différentes industries"
      },
      types: {
        sales: "Ventes",
        support: "Support Client",
        collections: "Recouvrements", 
        surveys: "Enquêtes",
        appointments: "Rendez-vous",
        retention: "Rétention"
      },
      industries: {
        banking: "Banque et Finance",
        healthcare: "Santé",
        retail: "Retail",
        telecom: "Télécommunications",
        insurance: "Assurance",
        automotive: "Automobile"
      },
      channels: {
        voicebot: "VoiceBot",
        chatbot: "ChatBot",
        human: "Agents Humains",
        hybrid: "Hybride"
      }
    },
    // Settings Panel
    settings: {
      title: "Configuration du Système",
      description: "Gérez votre compte, notifications, sécurité et intégrations",
      sections: {
        account: "Compte Utilisateur",
        notifications: "Notifications", 
        security: "Sécurité",
        integrations: "Intégrations",
        dashboards: "Tableaux de bord",
        appearance: "Apparence",
        export: "Exporter les Données"
      }
    },
    // Period Options
    periods: {
      last7days: "7 derniers jours",
      last30days: "30 derniers jours", 
      last90days: "90 derniers jours",
      thisMonth: "Ce mois",
      lastMonth: "Mois dernier",
      thisYear: "Cette année"
    },
    // Analytics Types
    analyticsTypes: {
      outbound: "Sortant",
      inbound: "Entrant", 
      outboundDesc: "Campagnes Sortantes",
      inboundDesc: "Support Entrant"
    },
    // Campaign Management
    campaignMgmt: {
      title: "Gestion des Campagnes Conversationnelles",
      subtitle: "Gérez les campagnes de voicebots, chatbots et agents humains dans différentes industries",
      statsActive: "Campagnes Actives",
      statsContacts: "Contacts Totaux",
      statsSuccess: "Taux de Réussite Moyen",
      statsRevenue: "Revenus Générés",
      filters: "Filtres",
      allIndustries: "Toutes les industries",
      allTypes: "Tous les types",
      tabAll: "Toutes",
      tabActive: "Actives",
      tabPaused: "Suspendues", 
      tabCompleted: "Terminées",
      progress: "Progrès",
      totalContacts: "Contacts Totaux",
      contactsCompleted: "Contacts Réalisés",
      successRate: "Taux de Réussite",
      avgDuration: "Durée Moyenne",
      revenueGenerated: "Revenus Générés",
      pauseCampaign: "Suspendre",
      resumeCampaign: "Reprendre",
      viewDetails: "Voir Détails",
      types: {
        sales: "Ventes",
        support: "Support Client",
        collections: "Recouvrements", 
        surveys: "Enquêtes",
        appointments: "Rendez-vous",
        retention: "Rétention"
      },
      industries: {
        banking: "Banque et Finance",
        healthcare: "Santé",
        retail: "Commerce",
        telecom: "Télécommunications",
        insurance: "Assurance",
        automotive: "Automobile"
      },
      channels: {
        voicebot: "VoiceBot",
        chatbot: "ChatBot",
        human: "Agents Humains",
        hybrid: "Hybride"
      }
    },
    // Campaign Details Modal
    campaignDetails: {
      edit: "Modifier",
      duplicate: "Dupliquer",
      export: "Exporter",
      totalContacts: "Contacts Totaux",
      contactsCompleted: "Contacts Réalisés", 
      successRate: "Taux de Réussite",
      avgDuration: "Durée Moyenne",
      revenueGenerated: "Revenus Générés",
      pauseCampaign: "Suspendre Campagne",
      resumeCampaign: "Reprendre Campagne",
      configure: "Configurer",
      refreshData: "Actualiser Données",
      detailedAnalysis: "Analyse Détaillée",
      interactiveDashboards: "Tableaux de bord interactifs spécifiques à cette campagne",
      status: {
        active: "Active",
        paused: "Suspendue",
        completed: "Terminée"
      }
    },
    // OSINT Panel
    osint: {
      intelligenceCenter: "Centre d'Intelligence OSINT",
      intelligenceDesc: "Intelligence actionnable à partir de sources ouvertes en temps réel",
      realtime: "En Direct",
      lastUpdate: "Dernière mise à jour: il y a 2 min",
      refresh: "Actualiser",
      export: "Exporter",
      timeframes: {
        "24h": "24h",
        "7days": "7 jours",
        "30days": "30 jours", 
        "90days": "90 jours"
      },
      metrics: {
        totalMentions: "Mentions Totales",
        sentimentScore: "Score de Sentiment",
        reachEstimate: "Portée Estimée",
        engagementRate: "Taux d'Engagement",
        criticalAlerts: "Alertes Critiques", 
        trendingTopics: "Sujets Tendance"
      },
      dataSources: "Sources de Données",
      sourcesLegend: "● Actif ○ Inactif",
      sources: {
        social: "Réseaux Sociaux",
        news: "Médias Numériques",
        forums: "Forums et Blogs",
        review: "Sites d'Avis",
        video: "Plateformes Vidéo"
      },
      mentions: "mentions",
      sentimentAnalysis: "Analyse de Sentiment",
      sentimentTypes: {
        positive: "Positif",
        neutral: "Neutre", 
        negative: "Négatif"
      },
      trending: "Sujets Tendance",
      trendingFilters: {
        all: "Tous",
        positive: "Positif",
        negative: "Négatif"
      },
      geographicDist: "Distribution Géographique",
      countries: {
        spain: "Espagne",
        mexico: "Mexique",
        argentina: "Argentine",
        colombia: "Colombie",
        chile: "Chili"
      },
      criticalAlerts: "Alertes Critiques",
      alertTypes: {
        negative_spike: "Pic de mentions négatives détecté",
        competitor_mention: "Comparaison avec concurrent détectée",
        viral_content: "Contenu viral positif sur la marque"
      },
      intelligenceReports: "Rapports d'Intelligence",
      reportTypes: {
        competitive: "Analyse Concurrentielle Hebdomadaire",
        reputation: "Détection de Crise de Réputation",
        opportunity: "Opportunités d'Engagement"
      },
      insights: "insights",
      confidence: "confiance",
      viewReport: "Voir Complet"
    },
    // Common
    common: {
      hours: "heures",
      minutes: "min",
      ago: "il y a",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      save: "Sauvegarder",
      cancel: "Annuler",
      close: "Fermer",
      search: "Rechercher",
      filter: "Filtre",
      all: "Tous",
      active: "Actif",
      inactive: "Inactif",
      yes: "Oui", 
      no: "Non"
    },
    // Footer
    footer: {
      tagline1: "Nous simplifions les données.",
      tagline2: "Nous multiplions les décisions.",
      login: "Se Connecter",
      newsletterTitle: "Restez Connecté",
      newsletterText: "Restez informé des dernières nouvelles, promotions et offres exclusives.",
      emailPlaceholder: "votre@email.com",
      submit: "Soumettre",
      submitting: "Envoi en cours...",
      subscriptionSuccess: "Abonnement réussi ! Merci de vous être inscrit.",
      social: "Social",
      pages: "Pages",
      info: "Informations",
      home: "Accueil",
      about: "À propos",
      properties: "Propriétés",
      contact: "Contact",
      privacy: "Politique de Confidentialité",
      copyright: "© Tous droits réservés par Amb Tu"
    }
  },
  pt: {
    // Navigation
    nav: {
      conversational: "Conversacional",
      reputational: "Monitorização Reputacional",
      tools: "Ferramentas",
      analytics: "Analíticas",
      campaigns: "Campanhas",
      conversations: "Conversações",
      reports: "Relatórios",
      osint: "Monitor OSINT",
      settings: "Configurações"
    },
    // Analytics Panel
    analytics: {
      title: "Analíticas Outbound",
      subtitle: "Toda a informação num clique",
      description: "Acompanhe, gira os seus clientes e a sua atividade",
      lastDays: "Últimos 30 dias",
      totalCalls: "Total Chamadas",
      attendedCalls: "Atendidas",
      abandonedCalls: "Abandonadas",
      avgDuration: "Duração Média",
      callDistribution: "Distribuição de resultados de chamadas",
      callEvolution: "Evolução de chamadas",
      campaignResults: "Resultados de campanhas",
      contracts: "Contratações",
      occupancy: "Ocupação",
      tma: "TMA",
      tme: "TME",
      confirmed: "Confirmada",
      modified: "Modificada",
      notConfirmed: "Não confirmada",
      cancelled: "Cancelada",
      dashboardReport: "Relatório Detalhado - Analíticas Avançadas",
      dashboardPlaceholder: "Dashboards interativos com analíticas avançadas",
      // Tab system labels
      tabs: {
        performanceMetrics: "Métricas de Performance",
        conversationAnalytics: "Analíticas Conversacionais",
        realTimeDashboard: "Dashboard em Tempo Real",
        kpiOverview: "Visão Geral de KPIs",
        performanceDesc: "Métricas principais de performance e produtividade",
        conversationDesc: "Análise detalhada de conversações e transcrições",
        realTimeDesc: "Monitorização em tempo real de atividade e chamadas",
        kpiDesc: "Indicadores-chave de performance e objetivos"
      }
    },
    // Campaigns Panel
    campaigns: {
      title: "Minhas campanhas",
      newCampaign: "Nova campanha",
      search: "Pesquisar",
      state: "Estado",
      clearFilters: "Limpar filtros",
      phoneNumber: "Número de telefone",
      campaignResult: "Resultado campanha",
      contacts: "Contactos",
      calls: "Chamadas",
      creationDate: "Data de criação",
      status: "Estado",
      draft: "Rascunho",
      paused: "Pausada",
      completed: "Concluída"
    },
    // Campaign Management
    campaignMgmt: {
      title: "Gestão de Campanhas Conversacionais",
      subtitle: "Gerencie campanhas de voicebots, chatbots e agentes humanos em diferentes indústrias",
      statsActive: "Campanhas Ativas",
      statsContacts: "Contatos Totais",
      statsSuccess: "Taxa de Sucesso Média",
      statsRevenue: "Receita Gerada",
      filters: "Filtros",
      allIndustries: "Todas as indústrias",
      allTypes: "Todos os tipos",
      tabAll: "Todas",
      tabActive: "Ativas",
      tabPaused: "Pausadas", 
      tabCompleted: "Concluídas",
      progress: "Progresso",
      totalContacts: "Contatos Totais",
      contactsCompleted: "Contatos Realizados",
      successRate: "Taxa de Sucesso",
      avgDuration: "Duração Média",
      revenueGenerated: "Receita Gerada",
      pauseCampaign: "Pausar",
      resumeCampaign: "Retomar",
      viewDetails: "Ver Detalhes",
      types: {
        sales: "Vendas",
        support: "Atendimento ao Cliente",
        collections: "Cobrança", 
        surveys: "Pesquisas",
        appointments: "Compromissos",
        retention: "Retenção"
      },
      industries: {
        banking: "Banco e Finanças",
        healthcare: "Saúde",
        retail: "Varejo",
        telecom: "Telecomunicações",
        insurance: "Seguros",
        automotive: "Automotivo"
      },
      channels: {
        voicebot: "VoiceBot",
        chatbot: "ChatBot",
        human: "Agentes Humanos",
        hybrid: "Híbrido"
      }
    },
    // Campaign Details Modal
    campaignDetails: {
      edit: "Editar",
      duplicate: "Duplicar",
      export: "Exportar",
      totalContacts: "Contatos Totais",
      contactsCompleted: "Contatos Realizados", 
      successRate: "Taxa de Sucesso",
      avgDuration: "Duração Média",
      revenueGenerated: "Receita Gerada",
      pauseCampaign: "Pausar Campanha",
      resumeCampaign: "Retomar Campanha",
      configure: "Configurar",
      refreshData: "Atualizar Dados",
      detailedAnalysis: "Análise Detalhada",
      interactiveDashboards: "Dashboards interativos específicos para esta campanha",
      status: {
        active: "Ativa",
        paused: "Pausada",
        completed: "Concluída"
      }
    },
    // Conversations Panel
    conversations: {
      title: "Conversações",
      all: "Todos",
      confirmed: "Confirmado",
      date: "Data",
      time: "Hora",
      phoneNumber: "Número de telefone",
      selectConversation: "Selecione uma conversação para ver os detalhes",
      back: "Voltar",
      contactInfo: "Ver informações de contacto",
      alternativeContact: "Contacto alternativo",
      fixedField: "Campo fixo",
      callAttempts: "Tentativas de chamada",
      callOrigin: "Origem da chamada",
      agentVoice: "Voz do agente",
      campaign: "Campanha",
      callState: "Estado",
      result: "Resultado",
      duration: "Duração",
      hungUpBy: "Desligado por",
      callSummary: "Resumo da chamada",
      callResults: "Resultados da chamada",
      alternativeTime: "Hora alternativa",
      deliveryDate: "Data de entrega",
      transcription: "Transcrição",
      thinking: "Pensamento",
      conversation: "Conversação",
      agent: "Agente Virtual",
      customer: "Cliente"
    },
    // Reports Panel
    reports: {
      title: "Vendas Madrid",
      finished: "Terminado em 23 de janeiro de 2025",
      download: "Descarregar",
      salesDistribution: "Distribuição das suas vendas",
      scheduled: "Agendada",
      interested: "Interessado",
      pending: "Pendente",
      rejected: "Rejeitada",
      evaluator: "Avaliador de Qualidade",
      evaluatorDesc: "Avalia conversações com compreensão real. Qualidade baseada na compreensão.",
      globalRating: "Classificação global",
      optimalPerformance: "O seu agente está tendo um desempenho ótimo em todas as áreas-chave.",
      customerSatisfaction: "Satisfação do cliente",
      callCompliance: "Conformidade de chamada",
      responseComplexity: "Complexidade de respostas",
      clarityIndex: "Índice de clareza",
      veryGood: "Muito bom",
      generalSummary: "Resumo geral",
      totalContacts: "Total de contactos",
      callAttempts: "Tentativas de chamada",
      totalConsumption: "Consumo total",
      campaignCost: "Custo da campanha",
      callBreakdown: "Foi assim que correram as suas chamadas",
      completed: "Concluídas",
      errors: "Erros",
      returned: "Devolvidas",
      voicemails: "Mensagens de voz",
      rescheduled: "Reagendadas",
      detailedAnalysis: "Análise Detalhada - Relatórios Avançados",
      dashboardPlaceholder: "Relatórios detalhados com métricas avançadas",
      // Tab system labels for reports
      tabs: {
        campaignReports: "Relatórios de Campanhas",
        osintReports: "Relatórios OSINT",
        customReports: "Relatórios Personalizados",
        performanceReports: "Relatórios de Performance",
        campaignDesc: "Análise detalhada de performance de campanhas",
        osintDesc: "Relatórios de monitorização e análise reputacional",
        customDesc: "Relatórios personalizáveis e configuráveis",
        performanceDesc: "Métricas de performance e KPIs principais"
      }
    },
    // OSINT Panel
    osint: {
      title: "Monitor OSINT",
      description: "Monitorização de fontes abertas e análise de reputação",
      filters: "Filtros",
      newSearch: "Nova pesquisa",
      overview: "Visão geral",
      mentions: "Menções",
      alerts: "Alertas",
      competitors: "Concorrência",
      totalMentions: "Menções Totais",
      positiveSentiment: "Sentimento Positivo",
      activeAlerts: "Alertas Ativos",
      monitoredSources: "Fontes Monitorizadas",
      mentionsByPlatform: "Menções por Plataforma",
      recentMentions: "Menções Recentes",
      sentiment: "Sentimento",
      interactions: "interações",
      allMentions: "Todas as Menções",
      searchMentions: "Pesquisar menções...",
      socialMonitoring: "Esta secção irá conectar-se com APIs de monitorização de redes sociais",
      keywordAlerts: "Alertas de Palavras-chave",
      seeDetails: "Ver detalhes",
      competitorAnalysis: "Análise de Concorrência",
      positive: "positivo",
      negative: "negativo",
      neutral: "neutro"
    },
    // OSINT Panel
    osint: {
      intelligenceCenter: "Centro de Inteligência OSINT",
      intelligenceDesc: "Inteligência acionável de fontes abertas em tempo real",
      realtime: "Ao Vivo",
      lastUpdate: "Última atualização: há 2 min",
      refresh: "Atualizar",
      export: "Exportar",
      timeframes: {
        "24h": "24h",
        "7days": "7 dias",
        "30days": "30 dias", 
        "90days": "90 dias"
      },
      metrics: {
        totalMentions: "Menções Totais",
        sentimentScore: "Score de Sentimento",
        reachEstimate: "Alcance Estimado",
        engagementRate: "Taxa de Engajamento",
        criticalAlerts: "Alertas Críticos", 
        trendingTopics: "Tópicos em Tendência"
      },
      dataSources: "Fontes de Dados",
      sourcesLegend: "● Ativo ○ Inativo",
      sources: {
        social: "Redes Sociais",
        news: "Mídia Digital",
        forums: "Fóruns e Blogs",
        review: "Sites de Avaliação",
        video: "Plataformas de Vídeo"
      },
      mentions: "menções",
      sentimentAnalysis: "Análise de Sentimento",
      sentimentTypes: {
        positive: "Positivo",
        neutral: "Neutro", 
        negative: "Negativo"
      },
      trending: "Tópicos em Tendência",
      trendingFilters: {
        all: "Todos",
        positive: "Positivo",
        negative: "Negativo"
      },
      geographicDist: "Distribuição Geográfica",
      countries: {
        spain: "Espanha",
        mexico: "México",
        argentina: "Argentina",
        colombia: "Colômbia",
        chile: "Chile"
      },
      criticalAlerts: "Alertas Críticos",
      alertTypes: {
        negative_spike: "Pico de menções negativas detectado",
        competitor_mention: "Comparação com concorrente detectada",
        viral_content: "Conteúdo viral positivo sobre a marca"
      },
      intelligenceReports: "Relatórios de Inteligência",
      reportTypes: {
        competitive: "Análise Competitiva Semanal",
        reputation: "Detecção de Crise de Reputação",
        opportunity: "Oportunidades de Engajamento"
      },
      insights: "insights",
      confidence: "confiança",
      viewReport: "Ver Completo"
    },
    // Footer
    footer: {
      tagline1: "Simplificamos os dados.",
      tagline2: "Multiplicamos as decisões.",
      login: "Entrar",
      newsletterTitle: "Mantenha-se Conectado",
      newsletterText: "Mantenha-se atualizado com as últimas notícias, promoções e ofertas exclusivas.",
      emailPlaceholder: "seu@email.com",
      submit: "Enviar",
      submitting: "Enviando...",
      subscriptionSuccess: "Inscrição bem-sucedida! Obrigado por se juntar a nós.",
      social: "Social",
      pages: "Páginas",
      info: "Informações",
      home: "Início",
      about: "Sobre",
      properties: "Propriedades",
      contact: "Contato",
      privacy: "Política de Privacidade",
      copyright: "© Todos os direitos por Amb Tu"
    },
    // Common
    common: {
      hours: "horas",
      minutes: "min",
      ago: "atrás",
      loading: "A carregar...",
      error: "Erro",
      success: "Sucesso"
    }
  }
};

export const languages = [
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'ca', name: 'Català', flag: '🏴' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' }
];